import { memo, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { formatPrice } from 'shared-modules/services';
import { isDisplayedNumber } from 'shared-modules/utils';
import styles from './numberText.module.scss';

export const NumberText = memo(({ value, symbol, className, symbolClassName }) => {
  const [num, isEmpty] = useMemo(() => {
    if (!isDisplayedNumber(value)) {
      return ['-', true];
    }
    return formatPrice({ value, allowZero: true, withoutPlus: true });
  }, [value]);
  return (
    <div className={classNames(styles.text, className)}>
      {num}
      {!isEmpty && <span className={classNames(styles.symbol, symbolClassName)}>{symbol}</span>}
    </div>
  );
});

NumberText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  symbol: PropTypes.string,
  symbolClassName: PropTypes.string,
};

NumberText.defaultProps = {
  value: undefined,
  className: undefined,
  symbol: '本',
  symbolClassName: undefined,
};
